// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__B5wR1","icon":"style_icon__PK53G","cicon":"style_cicon__xsrJS"};